import { render, staticRenderFns } from "./ModifyCertificateIndex.vue?vue&type=template&id=1ca03db8&scoped=true&"
import script from "./ModifyCertificateIndex.vue?vue&type=script&lang=js&"
export * from "./ModifyCertificateIndex.vue?vue&type=script&lang=js&"
import style0 from "./ModifyCertificateIndex.vue?vue&type=style&index=0&id=1ca03db8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca03db8",
  null
  
)

export default component.exports